import { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { InputSelect } from "../../components/formComponents/inputSelect";
import { InputFecha } from "../../components/formComponents/InputFecha";
import { DataContext } from "../../contextData/contextData";
import ErrorInput from "../../components/ui/ErrorInput";
import { TIPO_CONTRATO } from "../../utils/Constants";

export const CambioStatusContrato = (props) => {
  const { uno } = useContext(DataContext);
  const { formik } = props;

  const rtnListadoTipoContrato = (arr, tipo) =>
    tipo === "02"
      ? [{ value: "01", label: "Cambiar estatus a indefinido" }]
      : arr;

  useEffect(() => {
    if (["02"].includes(formik.values.tipo_cambio_contrato)) {
      formik.setTouched({ ...formik.touched, fecha_renovacion_contrato: true });
    }
  }, [formik.values.tipo_cambio_contrato]);

  return (
    <>
      <div>
        <InputSelect
          label="¿Que acción desea realizar? *"
          llave_texto="label"
          llave_valor="value"
          arr={rtnListadoTipoContrato(
            TIPO_CONTRATO,
            uno["REEO_NRO_TIPO_CONTRATO"]
          )}
          id="tipo_cambio_contrato"
          formik={formik}
        />
        {formik.errors.tipo_cambio_contrato !== undefined &&
          formik.touched.tipo_cambio_contrato !== undefined && (
            <ErrorInput
              touched={formik.touched.tipo_cambio_contrato}
              error={formik.errors.tipo_cambio_contrato}
            />
          )}
      </div>
      {["02"].includes(formik.values.tipo_cambio_contrato) && (
        <InputFecha
          formik={formik}
          label="Fecha extensión de plazo fijo *"
          id="fecha_renovacion_contrato"
        />
      )}
    </>
  );
};

CambioStatusContrato.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({
      tipo_cambio_contrato: PropTypes.string,
    }),
    touched: PropTypes.object,
    errors: PropTypes.object,
    setTouched: PropTypes.func,
  }).isRequired,
};
